import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Toolbar from '@mui/material/Toolbar';
import React, { useState } from 'react';

import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import Link from '@mui/material/Link';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import NorthAmericanFullColorSVGR from '../../assets/svgr/NorthAmericanFullColorSVGR';
import { appBarLinks, LOGO_URL } from '../../constants';
import CollapsedMenu from './CollapsedMenu';

const Header = () => {
  const [openSubLinks, setOpenSubLinks] = useState(false);

  const onMenuHover = (link) => {
    if (link.subLinks?.length > 0) {
      setOpenSubLinks(true);
    } else {
      setOpenSubLinks(false);
    }
  };

  const onMenuUnHover = () => {
    setOpenSubLinks(false);
  };

  return (
    <AppBar sx={{ position: { xs: 'fixed', customheadermobile: 'sticky' } }} className='header-app-bar' color='inherit'>
      <Toolbar disableGutters>
        <Container maxWidth={false}>
          <Grid
            container
            direction='row'
            justifyContent='flex-start'
            alignItems='center'
          >
            <Grid>
              <Link href={LOGO_URL} aria-label='Home' className='home-link'>
                <NorthAmericanFullColorSVGR />
              </Link>
            </Grid>
            <Box className='menu'>
              <Toolbar disableGutters>
                <Box sx={{ display: { xs: 'none', customheadermobile: 'block' } }}>
                  <Grid container direction='row' className='link-container' alignContent='center' alignItems='center'>
                    {appBarLinks.map((link) => (
                      <>
                        <a
                          key={link.name}
                          aria-label={link.name}
                          className={`header-link ${link.active ? 'active' : ''}`}
                          href={link.url}
                          onMouseEnter={() => onMenuHover(link)}
                          onClick={onMenuUnHover}
                        >
                          <Typography component='span'>
                            {link.name.map((name) => (<p className='title' key={name}>{name}</p>))}
                          </Typography>
                          {
                            link.subLinks?.length > 0
                          && <ArrowDropDownIcon />
                          }
                        </a>
                        {
                          link.subLinks?.length > 0 && openSubLinks && (
                            <Box className='header-sub-link' ml={65.2} onMouseLeave={onMenuUnHover}>
                              {
                                link.subLinks?.map(({ name, url }) => (
                                  <a href={url} key={url}>
                                    {name.map((text) => (<p key={text}>{text}</p>))}
                                  </a>
                                ))
                              }
                            </Box>
                          )
                        }
                      </>
                    ))}
                  </Grid>
                </Box>
                <Box sx={{ display: { xs: 'block', customheadermobile: 'none' } }} justifyContent='right'>
                  <CollapsedMenu items={appBarLinks} />
                </Box>
              </Toolbar>
            </Box>
            <Grid item xs={12}>
              <Box sx={{ mt: { xs: 1, customheadermobile: 0 }, mb: { xs: 1, customheadermobile: 0 } }}>
                <Typography className='icon-text'>Issued by North American Company for Life and Health Insurance&reg;</Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
